import styled from 'styled-components'
import { Alert, Card } from '@amzn/storm-ui'

export const AlertContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.large};
  display: flex;
  justify-content: center;
`
export const StyledAlert = styled(Alert)`
  width: 49%;
`
export const StyledCard = styled(Card)`
  width: 50%;
  margin: auto;
`

export const FormColumn = styled.div`
  margin-top: ${({ theme }) => theme.spacing.large};
  display: flex;
  flex-direction: column;
`
